import classnames from 'classnames';
import { bemHelper } from '@dbk/ui-react-utils';

import styles from '../popover.css';

const containerWrapper = bemHelper(styles, 'container-wrapper');
const contentWrapper = bemHelper(styles, 'content-wrapper');

export const getWidth = (mode, orientation) => {
  if (
    mode === 'inline' &&
    (orientation === 'top' || orientation === 'bottom')
  ) {
    return { width: '100%' };
  }
  return {};
};

const getClassNameForThemeType = (themeType, orientation) => {
  if (themeType === 'alert' || themeType === 'warning') {
    return `${themeType}-${orientation}`;
  }
  return themeType;
};

export const getContentWrapperClassNames = (
  orientation,
  popOverClassName,
  showCloseButton,
  inverse,
  type
) =>
  classnames(
    'content-wrapper',
    popOverClassName,
    contentWrapper(null, orientation),
    contentWrapper(null, getClassNameForThemeType(type, orientation)),
    {
      [contentWrapper(null, 'close-button-layout')]: showCloseButton,
      [contentWrapper(null, 'inverse')]: inverse,
    }
  );

export const getContainerWrapperClassNames = (closing, mode, orientation) =>
  classnames(
    'container-wrapper',
    containerWrapper(null, `${mode}-${orientation}`),
    {
      [containerWrapper(null, 'fadingIn')]: closing === false,
      [containerWrapper(null, 'fadingOut')]: closing === true,
    }
  );
